(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("bMmzY", function(module, exports) {
const $8935b12b9b0f8d03$var$toggleableElements = document.querySelectorAll("[data-toggle-trigger]");
$8935b12b9b0f8d03$var$toggleableElements.forEach((element)=>{
    const triggerSelector = element.dataset.toggleTrigger;
    if (!triggerSelector) return;
    const trigger = element.querySelector(triggerSelector);
    if (!trigger) return;
    trigger.addEventListener("click", (e)=>{
        e.preventDefault();
        trigger.classList.contains("--triggered") ? trigger.classList.remove("--triggered") : trigger.classList.add("--triggered");
        element.classList.contains("--toggled") ? element.classList.remove("--toggled") : element.classList.add("--toggled");
    });
});

});

})();
//# sourceMappingURL=toggler.dce00a35.js.map
